var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('b-container',[_c('b-navbar',{attrs:{"variant":"faded","type":"light"}},[_c('b-navbar-brand',{attrs:{"href":"#"}},[_c('Logo')],1),_c('b-navbar-brand',{staticClass:"ml-auto vconsol-logo",attrs:{"href":"#"}},[_c('vconsol-logo')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }